// TODO (Next.js migration): replace useLocation with useSearchParams from next/navigation
import { useLocation } from 'react-router-dom';

const useIsOnReviewStep = () => {
  const { search } = useLocation();
  return new URLSearchParams(search).get('step')?.toLowerCase() === 'review';
};

export default useIsOnReviewStep;
